import template from './loansRouting.html';
import controller from './loansRouting.controller';
import './loansRouting.scss';

let loansRoutingComponent = {
  restrict: 'E',
  bindings: {
    moduleClosed: '<'
  },
  template,
  controller
};

export default loansRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRouting/loansRouting.component.js